/**
 *
 */

const engine = require('store/src/store-engine')

// https://github.com/marcuswestin/store.js#storages
const storages = [
  require('store/storages/localStorage'),
  require('store/storages/cookieStorage')
];

// https://github.com/marcuswestin/store.js#plugins
const plugins = [
  // require('store/plugins/all'),
  require('store/plugins/defaults')
  // require('store/plugins/expire'),
  // require('store/plugins/observe'),
  // etc.
];

const store = engine.createStore(storages, plugins);

export default store;


// WEBPACK FOOTER //
// ./src/wrappers/localstore.js